<template>
  <div class="mobile-layer-toggles">
    <button type="button" class="layer-btn" :class="{ active: layers.anomalies }"
      @click="toggle('anomalies')" aria-label="Toggle anomalies">
      <v-icon size="20" :color="layers.anomalies ? '#3b82f6' : '#5a6970'">
        {{ layers.anomalies ? 'mdi-eye' : 'mdi-eye-off-outline' }}
      </v-icon>
      <span class="layer-label">Anomalies</span>
    </button>

    <button type="button" class="layer-btn" :class="{ active: layers.hotspots }"
      @click="toggle('hotspots')" aria-label="Toggle hotspots">
      <v-icon size="20" :color="layers.hotspots ? '#ef4444' : '#5a6970'">
        {{ layers.hotspots ? 'mdi-fire-alert' : 'mdi-fire-off' }}
      </v-icon>
      <span class="layer-label">Hotspots</span>
    </button>

    <button type="button" class="layer-btn" :class="{ active: layers.zones }"
      @click="toggle('zones')" aria-label="Toggle inspection zones">
      <v-icon size="20" :color="layers.zones ? '#66c7b4' : '#5a6970'">
        {{ layers.zones ? 'mdi-select-group' : 'mdi-select-off' }}
      </v-icon>
      <span class="layer-label">Zones</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useViewerUiStore } from '@/store/viewerUiStore';

const viewerUi = useViewerUiStore();
const layers = computed(() => viewerUi.layers);
const toggle = (key) => viewerUi.toggleLayer(key);
</script>

<style scoped>
.mobile-layer-toggles {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  border-radius: 14px;
  background: rgba(18, 25, 30, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
}

.layer-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 38px;
  padding: 0 13px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  color: #8aa0aa;
  font: inherit;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.layer-btn.active {
  color: #eef3f2;
  border-color: rgba(100, 255, 218, 0.25);
  background: rgba(100, 255, 218, 0.08);
}

.layer-label { white-space: nowrap; flex: 1 1 auto; }
</style>
